<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <div class="all">
      <div class="searchtop">
        <div class="searchtop-title">筛选查询</div>
        <el-button type="primary"
                   class="seniorbuton"
                   @click="seniorShowClick">高级搜索</el-button>
        <el-button type="primary"
                   class="seniorbuton"
                   v-if="seniorshow"
                   style="margin-right: 10px"
                   @click="seniorHiddenClick"
                   plain>收起筛选</el-button>
      </div>
      <el-form label-width="90px"
               style="margin-top: 5px"
               :model="dataForm">
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="企业名称">
              <el-input v-model="dataForm.companyName"
                        placeholder="企业名称"
                        style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="认证状态">
              <el-select v-model="dataForm.authentFlag"
                         placeholder="请选择">
                <el-option v-for="item in options"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="提注册时间">
              <el-date-picker v-model="value1"
                              type="daterange"
                              style="width: 120%"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-button style="float: right; margin-right: 10px">重置</el-button>
            <el-button type="primary"
                       style="float: right; margin-right: 10px">查询</el-button>
          </el-col>
        </el-row>
      </el-form>
      <el-form label-width="90px"
               style="margin-top: 5px"
               v-show="seniorshow"
               :model="dataForm">
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="客户ID">
              <el-input v-model="dataForm.companyId"
                        placeholder="客户ID"
                        style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="信用代码">
              <el-input v-model="dataForm.socialCreditCode"
                        placeholder="信用代码"
                        style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="客户负责人">
              <el-input v-model="dataForm.name"
                        placeholder="客户负责人"
                        style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="状态">
              <el-select v-model="dataForm.enableStatus"
                         placeholder="请选择">
                <el-option v-for="item in options"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table :data="tableData"
                border
                style="width: 100%">
        <el-table-column type="index"
                         label="序号"
                         fixed
                         width="50">
        </el-table-column>
        <el-table-column fixed
                         prop="companyId"
                         label="企业ID"
                         width="150">
        </el-table-column>
        <el-table-column prop="companyName"
                         label="企业名称"
                         width="120">
        </el-table-column>
        <el-table-column prop="socialCreditCode"
                         label="统一社会信用代码"
                         min-width="200">
        </el-table-column>
        <el-table-column prop="name"
                         label="客户负责人"
                         width="120">
        </el-table-column>
        <el-table-column prop="registerEndTime"
                         label="注册时间"
                         width="250">
        </el-table-column>
        <el-table-column prop="authentFlag"
                         label="认证状态"
                         width="120">
        </el-table-column>
        <el-table-column prop="zip"
                         label="状态"
                         width="120">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.enableStatus"
                       @change="changeStauts(scope.row,scope.$index)"
                       active-color="#13ce66"
                       inactive-color="#ccc">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="80">
          <template slot-scope="scope">
            <el-button @click="goEdit(scope.row)"
                       type="text"
                       size="small">编辑</el-button>
            <el-dropdown trigger="click">
              <span class="el-dropdown-link"
                    style="cursor: pointer">
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="doDelete">删除</el-dropdown-item>
                <el-dropdown-item @click.native="doOverrule">驳回</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page="page"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="limit"
                     :total="total"
                     layout="total, sizes, prev, pager, next, jumper"
                     @size-change="pageSizeChangeHandle"
                     @current-change="pageCurrentChangeHandle">
      </el-pagination>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/log/login/page',
        getDataListIsPage: true,
        exportURL: '/sys/log/login/export'
      },
      dataForm: {},
      value: false,
      // registerStartTime registerEndTime
      value1: [],
      seniorshow: false,
      options: [
        {
          value: '选项1',
          label: '北京烤鸭'
        },
        {
          value: '选项2',
          label: '北京烤鸭'
        },
        {
          value: '选项3',
          label: '北京烤鸭'
        },
        {
          value: '选项4',
          label: '北京烤鸭'
        },
        {
          value: '选项5',
          label: '北京烤鸭'
        }
      ],
      tableData: [
        {
          date: '12345',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1516 弄',
          zip: 200333,
          enableStatus: false
        },
        {
          date: '12345',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1516 弄',
          zip: 200333,
          enableStatus: false
        },
        {
          date: '12345',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1516 弄',
          zip: 200333,
          enableStatus: false
        },
        {
          date: '12345',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1516 弄',
          zip: 200333,
          enableStatus: false
        }
      ]
    }
  },
  methods: {
    seniorShowClick () {
      this.seniorshow = true
    },
    seniorHiddenClick () {
      this.seniorshow = false
    },
    goEdit (row) {
      this.$router.push({
        name: 'sys-industrial-organization-businessdetails'
      })
    },
    // 禁用
    changeStauts (val, index) {
      if (val.enableStatus === true) {
        this.$confirm('确定要启用该企业客户吗？启用后其下属企业客户将可以登录', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          closeOnClickModal: false,
          closeOnPressEscape: false
        }).then(() => {
          this.$http.post('/help/user/sys/custUser/updateEnable', {
            custId: val.custId,
            enableStatus: '1'
          }, {
            headers: {
              'content-type': 'application/x-www-form-urlencoded',
              'Authorization': 'Basic cmVucmVuaW86cmVucmVuaW8='
            }
          }).then(({ data: res }) => {
            if (res.code === 0) {
              this.$message({
                type: 'success',
                message: '启用成功!'
              })
              this.getDateList()
            }
          }).catch(() => { })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消启用'
          })
          this.tableData[index].enableStatus = false
        })
      } else {
        this.$confirm('确定要禁用该企业客户吗？禁用后其下属企业客户将无法登录', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          closeOnClickModal: false,
          closeOnPressEscape: false
        }).then(() => {
          this.$http.post('/help/user/sys/custUser/updateEnable', {
            custId: val.custId,
            enableStatus: '0'
          }, {
            headers: {
              'content-type': 'application/x-www-form-urlencoded',
              'Authorization': 'Basic cmVucmVuaW86cmVucmVuaW8='
            }
          }).then(({ data: res }) => {
            if (res.code === 0) {
              this.$message({
                type: 'success',
                message: '禁用成功!'
              })
              this.getDateList()
            }
          }).catch(() => { })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消禁用'
          })
          this.tableData[index].enableStatus = true
        })
      }
    },
    // 删除
    doDelete () {
      this.$confirm('确定要删除该企业客户吗？删除后其下属企业客户将无法登录', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(() => {
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 驳回
    doOverrule () {
      this.$confirm('确定要驳回该企业客户吗？驳回后其下属企业客户将无法登录', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(() => {
        this.$message({
          type: 'success',
          message: '驳回成功!'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消驳回'
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped="scoped">
.searchtop {
  height: 40px;
  width: 100%;
  line-height: 40px;
  background-color: #f3f3f3;
  padding-left: 20px;
  padding-right: 20px;
  border: 1px solid #dcdfe6;
  .searchtop-title {
    line-height: 40px;
    color: #303133;
    float: left;
  }
  .seniorbuton {
    margin-top: 5px;
    float: right;
  }
}
.allnumber {
  width: 100%;
  height: 25px;
  line-height: 25px;
  background-color: #e2f3fc;
  margin-top: 5px;
  font-size: 12px;
  padding-left: 20px;
  color: #606266;
}
</style>
<style>
.searchtop .el-button {
  height: 30px;
  padding: 5px 10px;
}
</style>
